import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { contentServiceGet } from '../../lib/utils.js'
import focusable from '../../components/Focusable/Focusable'
import Spinner from '../../components/Spinner/Spinner'
import Grid from '../../components/Grid/Grid'
import * as UI from '../../lib/ui'
import tts from '../../lib/TTS'
import { store } from '../../store'
import {
  ComcastErrorType,
  getUrlSearchParameter,
} from '../../../../shared/helpers'
import googleAnalytics4 from '../../lib/googleAnalytics.js'
import { withRouter } from '../../../../shared/components/WithRouter/WithRouter'

const STATIONID = 'station_id'
class CollectionsScreen extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      id: 'CollectionsScreen',
      spinnerVisible: true,
      collection: [],
    }

    UI.setLoadingState(true)

    this.gridRef = React.createRef()
  }

  onKeyEvent(key) {
    let handled = false

    if ('BACK' === key) {
      this.props.router.navigate(-1)
    }

    return handled
  }

  componentDidMount() {
    let link = decodeURIComponent(this.props.router.params.url)

    const stationId = getUrlSearchParameter(
      this.props.router.location.search,
      STATIONID
    )
    if (!stationId) {
      link += `?${STATIONID}=${this.props.stationId}`
    }
    UI.registerFocusableComponent({ screen: this.state.id })
    this.getCollectionData(link)
  }

  getCollectionData(url) {
    contentServiceGet(url)
      .then((resp) => {
        const header = resp.resource.title

        let respCollection = resp.collections[0].content.concat(
          this.state.collection
        )

        this.setState(
          {
            collection: respCollection,
            spinnerVisible: false,
            header,
            focusedComponent: 'grid',
          },
          () => {
            tts.pushTextToRead(`${this.state.header}`)
            tts.addTextToRead(`${this.state.collection[0].title}`)
            this.gridRef.current?.setFocus()
            googleAnalytics4.sendPageViewEvent(
              `See All Collections | ${header}`
            )
          }
        )
        UI.setLoadingState(false)
      })
      .catch((error) => {
        UI.setLoadingState(false)
        store.dispatch({
          type: 'TRIGGER_ERROR',
          payload: {
            error: {
              content: {
                error,
                errorPath: this.props.router.location.pathname,
              },
              codeBaseLocation: 'CollectionsScreen - getCollectionData',
              errorType: ComcastErrorType.network,
            },
          },
        })

        this.props.router.navigate('/error', { replace: true })
      })
  }

  render() {
    const { collection, spinnerVisible } = this.state
    const view = collection[0]?.item_type

    return (
      <>
        <Spinner visible={spinnerVisible} screen={true} />
        {!spinnerVisible && (
          <Grid
            view={view}
            collection={collection}
            collectionType="single"
            parent={this}
            ref={this.gridRef}
          />
        )}
      </>
    )
  }
}

CollectionsScreen.propTypes = {
  router: PropTypes.shape({
    navigate: PropTypes.func,
    params: PropTypes.shape({
      url: PropTypes.string,
    }),
    location: PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
    }),
  }),
  stationId: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    stationId: state.station.station_id,
    ui: state.ui,
    uid: state.device.UID,
  }
}

export default connect(
  mapStateToProps,
  null,
  null
)(withRouter(focusable(CollectionsScreen)))
